import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileDetail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "#FEF3E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 31.0039H16C12 31.0039 11 30.0039 11 26.0039V16.0039C11 12.0039 12 11.0039 16 11.0039H17.5C19 11.0039 19.33 11.4439 19.9 12.2039L21.4 14.2039C21.78 14.7039 22 15.0039 23 15.0039H26C30 15.0039 31 16.0039 31 20.0039V22.0039",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7586 27.3243C20.4086 27.4943 20.4086 30.8943 22.7586 31.0643H28.3186C28.9886 31.0643 29.6486 30.8143 30.1386 30.3643C31.7886 28.9243 30.9086 26.0443 28.7386 25.7743C27.9586 21.0843 21.1786 22.8643 22.7786 27.3343",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFileDetail;
